import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

/** @type {import('@supabase/supabase-js').SupabaseClient | undefined} */
const GLOBAL_KEY = '__mashhad_supabase_client__';

function createSupabaseClient() {
  return createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: 'mashhad-app-auth',
      // Buffer concurrent auth ops (getSession, refresh, onAuthStateChange)
      lockAcquireTimeout: 10_000,
    },
  });
}

/**
 * Single Supabase client for the whole app (survives Vite HMR without duplicating
 * clients that fight over lock:mashhad-app-auth).
 */
export const supabase = globalThis[GLOBAL_KEY] ?? (globalThis[GLOBAL_KEY] = createSupabaseClient());
